import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';

export const callConfigGetApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.apiConfig, {
    params: {
      ServiceName: payload,
    },
  });
  return data;
};
